export default function IconArrowUpDown({
  color = "#575656",
  width = "6",
  height = "10",
  direction = "right",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${direction === "right" ? 0 : 180})`}
    >
      <path
        d="M1.0127 9L5.0127 5L1.01269 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
